import {
  Box,
  Typography,
  Button,
  CircularProgress,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as Logo } from "../../assets/svg/Logo.svg";
import { ReactComponent as BackIcon } from "../../assets/svg/BackIcon.svg";
import CInput from "../../components/CInput";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { Setting } from "../../utils/Setting";
import { getApiData } from "../../utils/APIHelper";
import { useNavigate } from "react-router-dom";
import useStyles from "./styles";
import Reset from "./components/Reset";
import { ReactComponent as TabletLogo } from "../../assets/svg/TabletLogo.svg";

const errorObj = {
  emailErr: false,
  passwordErr: false,
  forgotEmailErr: false,
  emailMsg: "",
  passwordMsg: "",
  forgotEmailMsg: "",
};

function ForgotPassword() {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const navigate = useNavigate();
  const theme = useTheme();
  const isTablet = useMediaQuery("(max-width:1024px)");
  const isMobile = useMediaQuery("(max-width:820px)");

  const classes = useStyles();

  const [step, setStep] = useState(0);
  const [email, setEmail] = useState("");
  const [errObj, setErrObj] = useState(errorObj);
  const [btnLoad, setBtnLoad] = useState(false);

  function validation() {
    const error = { ...errObj };
    let valid = true;
    // validate forgot email
    if (isEmpty(email)) {
      valid = false;
      error.emailErr = true;
      error.emailMsg = "Please enter email";
    } else if (!emailRegex.test(email)) {
      valid = false;
      error.emailErr = true;
      error.emailMsg = "Please enter valid email";
    }

    setErrObj(error);
    if (valid) {
      forgotPasswordApiCall();
    }
  }

  async function forgotPasswordApiCall() {
    try {
      setBtnLoad(true);
      const response = await getApiData(
        Setting.endpoints.forgotPassword,
        "POST",
        {
          email: email ? email : "",
          device_type: "web",
        }
      );

      console.log("response ====forgot otp=>>> ", response);
      if (response.success) {
        setStep(1);
      } else {
        toast.error(response.message);
      }
      setBtnLoad(false);
    } catch (error) {
      console.log("🚀 ~ file: index.js:88 ~ resendOtp ~ error:", error);
      toast.error(error.toString() || "Something gone wrong! Please try again");
      setBtnLoad(false);
    }
  }

  function handleClick() {
    if (step === 0) {
      navigate("/user-login");
    } else {
      setStep(0);
      setEmail("");
      setErrObj(errorObj);
    }
  }

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          backgroundImage:
            step === 0
              ? 'url("/assets/images/bg3.png")'
              : 'url("/assets/images/bg2.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          textAlign: "center",
          px: 3,
        pt: isMobile ? 4 : isTablet ? 4 : 8,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
          gap: isMobile ? "35px" : isTablet ? "15px" : "20px",
            width: isMobile ? "100%" : isTablet ? "60% " : "50%",
          }}
        >
          <div>
         {isTablet ? <TabletLogo/> : <Logo />}   
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <BackIcon onClick={handleClick} style={{ cursor: "pointer" }} />
            <div
              style={{
                width: "100%",
              fontSize: isMobile ? "1.3rem" : isTablet ? "1.3rem" : "40px",
                fontFamily: "Inter Tight",
                textAlign: "center",
                fontWeight: "600",
                color: "#000000",
                letterSpacing: "-0.4px",
              }}
            >
              {step === 0 ? "Forgot" : "Reset"} password
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              width: isMobile ? "95%" : "55%",
              textAlign: "left",
            }}
          >
            {step === 0 ? (
              <>
                <CInput
                  label="Email Address"
                  placeholder="Enter email address"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setErrObj({ ...errObj, emailErr: false, emailMsg: "" });
                  }}
                  white={false}
                  error={errObj.emailErr}
                  helpertext={errObj.emailMsg}
                  className={classes.label}
                />

                <center>
                  <button
                    style={{
                      marginTop: "2vh",
                      width: "fit-content",
                      padding: isMobile ? "1.5vh 10vw" : "1.5vh 5vw",
                      backgroundColor: "#4D6BF6",
                      borderRadius: "12px",
                      fontSize: "16px",
                      fontWeight: "600",
                      boxShadow: "none",
                      border: "1px solid transparent",
                      color: "#fff",
                      cursor: "pointer",
                      fontFamily: "Inter Tight",
                      textAlign: "center",
                    }}
                    onClick={validation}
                    disabled={btnLoad}
                  >
                    {btnLoad ? (
                      <CircularProgress size={24} sx={{ color: "#fff" }} />
                    ) : (
                      "Send OTP"
                    )}
                  </button>
                </center>
              </>
            ) : (
              <Reset />
            )}
          </div>
        </Box>
      </Box>
    </>
  );
}

export default ForgotPassword;
